var guid = require('./guid');

module.exports = guid;


/*****************
 ** WEBPACK FOOTER
 ** ./~/lite-guid/index.js
 ** module id = 43
 ** module chunks = 0
 **/